// extracted by mini-css-extract-plugin
export default {"main-layout-root":"MainLayout_main-layout-root__RNFZb","main-content":"MainLayout_main-content__prMCh"};